const NAV_LIST = [
  {
    id: 1,
    name: 'Home',
    path: '/',
  },
  {
    id: 2,
    name: 'Form',
    path: '/form',
  },
  {
    id: 3,
    name: 'About Us',
    path: '/about',
  },
];

export default NAV_LIST;
